import request from '@/utils/request'


export function addContact(data) {
  return request({
    url: '/wms/llhs/addOrEdit',
    method: 'post',
    data: data
  })
}